import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const OverviewsIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
      fill="none"
    >
      <path
        d="M11.9841 15.5L4.73406 7.35C4.38406 6.95 3.73406 6.9 3.33406 7.25C2.93406 7.6 2.88406 8.25 3.23406 8.65L11.2341 17.65C11.4341 17.9 11.6841 18 11.9841 18C12.2841 18 12.5341 17.9 12.7341 17.65L20.7341 8.65C20.8841 8.45 20.9841 8.2 20.9841 8C20.9841 7.7 20.8841 7.45 20.6341 7.25C20.2341 6.9 19.5841 6.9 19.2341 7.35L11.9841 15.5Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(OverviewsIcon);
